export const cloneConfigModal = {
  close: "Zamknij",
  searchPlaceholder: "Szukaj oferty…",
  clearSearch: "Wyczyść",
  bar: {
    chooseSource: "Proszę wybrać ofertę źródłową",
    selected: "{count} zaznaczona | {count} zaznaczone | {count} zaznaczonych",
    selectAll: "Zaznacz wszystkie",
    clear: "Wyczyść",
  },
  list: {
    loading: "Wczytywanie ofert…",
    empty: "Żadna oferta nie pasuje do wyszukiwania.",
    unitsBadge: "{count} jednostek",
  },
  confirm: {
    sourceLabel: "Wybrane źródło",
    applyToLabel: "Zostanie zastosowane do",
    andItsUnits: "(oraz do jej jednostek w liczbie {count})",
    andMore: "i jeszcze {count}",
    undoWarning: "Tej operacji nie da się cofnąć.",
  },
  footer: {
    back: "Wstecz",
    cancel: "Anuluj",
    continue: "Dalej",
  },
  preview: {
    unit: "Jednostka",
    listing: "Oferta",
    empty: "Brak konfiguracji.",
    loading: "Wczytywanie…",
  },
  confirmTitle: {
    pull: "Potwierdzenie przed przeniesieniem",
    push: "Przegląd przed skopiowaniem",
  },
  confirmLabel: {
    pulling: "Przenoszenie…",
    copying: "Kopiowanie…",
    confirmPull: "Tak, przenieś ustawienia",
    confirmPush: "Tak, skopiuj do {count} oferty | Tak, skopiuj do {count} ofert | Tak, skopiuj do {count} ofert",
  },
  intro: {
    pullLead: "Do przeniesienia z wybranej oferty: {noun}.",
    pullReplace: "Obecna zawartość zostanie tu zastąpiona.",
    pullAdd: "Nowe elementy zostaną dodane do tego, co już tu jest.",
    pushLead: "Do skopiowania do {count} oferty: {noun}. | Do skopiowania do {count} ofert: {noun}. | Do skopiowania do {count} ofert: {noun}.",
    pushReplace: "Obecna zawartość zostanie tam zastąpiona{scope}. | Obecna zawartość zostanie tam zastąpiona{scope}. | Obecna zawartość zostanie tam zastąpiona{scope}.",
    pushAdd: "Nowe elementy zostaną dodane do tego, co już tam jest. | Nowe elementy zostaną dodane do tego, co już tam jest. | Nowe elementy zostaną dodane do tego, co już tam jest.",
    pushScope: ", łącznie z ustawieniami wysyłki",
  },
  attachments: {
    fileFallback: "Załącznik",
    titleAlsoCopied: "Załączniki też zostaną skopiowane",
    titlePullLose: "Obecne załączniki zostaną utracone",
    titlePullGain: "Jej załączniki również zostaną przeniesione",
    titlePushEmpty: "Wybrane oferty zostaną bez załączników",
    noteUnknownPull: "Załączniki z wybranej oferty zastąpią te, które są tutaj, a obecne zostaną usunięte.",
    noteUnknownPush: "Załączniki z tej oferty zastąpią te w wybranych ofertach, a obecne zostaną usunięte.",
    notePullReplace: "Zostaną usunięte i zastąpione tymi z wybranej oferty.",
    notePullEmpty: "Nie ma tu teraz żadnych załączników, więc nic nie zostanie utracone: zostaną przeniesione te z wybranej oferty.",
    notePushEmpty: "Ta oferta nie ma załączników, więc te w wybranej ofercie zostaną usunięte i pozostanie ona bez załączników. | Ta oferta nie ma załączników, więc te w wybranych ofertach zostaną usunięte i pozostaną one bez załączników. | Ta oferta nie ma załączników, więc te w wybranych ofertach zostaną usunięte i pozostaną one bez załączników.",
    notePushReplace: "Zostaną skopiowane do wybranej oferty i zastąpią jej własne, które zostaną usunięte. | Zostaną skopiowane do wybranych ofert i zastąpią ich własne, które zostaną usunięte. | Zostaną skopiowane do wybranych ofert i zastąpią ich własne, które zostaną usunięte.",
  },
  toast: {
    loadError: "Nie udało się wczytać ofert",
    pullSuccess: "Ustawienia zostały przeniesione",
    pushSuccess: "Ustawienia skopiowane do {count} oferty | Ustawienia skopiowane do {count} ofert | Ustawienia skopiowane do {count} ofert",
    pullError: "Nie udało się przenieść ustawień",
    pushError: "Nie udało się skopiować ustawień",
  },
};
